import { requestREST } from "~/client/http/CommonHTTP";

export interface EpdBlockIProps {
  id: number | null;
  operatorInn: string | null;
  operatorName: string | null;
  edoAccountId: string | null;
  edoOperatorCode: string | null;
  signerCode: string | null;
  signerName: string | null;
  signerPosition: string | null;
  mchdGuid: string | null;
  mchdValidFrom: string | null;
  mchdUrl: string | null;
  signerAuthorityCodes: string | null;
}

export interface DealerEpdIProps {
  dealer: {
    id: number;
    name: string;
  };
  epdBlocks: EpdBlockIProps[];
}

export const getEpd = async (dealerId: string): Promise<DealerEpdIProps> => {
  const { data } = await requestREST.get("/dealer/epd", {
    params: { id: dealerId },
  });
  return data;
};
